import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { cn } from '@/lib/utils'
import { useConnectModal } from '@rainbow-me/rainbowkit'
import { testIdFactory } from '@/utils/test-id-factory.ts'

export function WelcomeCard({ className }: { className?: string }) {
	const { openConnectModal } = useConnectModal()

	return (
		<Card className={cn('flex flex-col-reverse md:flex-row p-6 md:p-10 justify-between gap-8', className)}>
			<div className="flex flex-col gap-8">
				<h3 className="uppercase text-neutral-50 text-5xl leading-none text-center md:text-left">
					Welcome to Pepper Inc.
				</h3>
				<div className="flex flex-col gap-3">
					<p className="flex flex-col leading-6 text-2xl text-neutral-40">
						<span>Where the community gets spicy, and decisions get even spicier!</span>
						<span>Stake your PEPPER and dive into the action:</span>
					</p>
					<ul className="list-disc text-neutral-40 text-2xl leading-6 pl-7">
						<li>Vote on the hottest topics</li>
						<li>Shape the future of PEPPER</li>
						<li>Manage the community treasury like a true PEPPER boss!</li>
					</ul>
				</div>
				<Button
					variant="danger"
					onClick={openConnectModal}
					className="self-stretch md:self-start py-5 px-10 leading-none"
					data-testid={testIdFactory.pepperConnectWalletButton()}
				>
					Connect Wallet
				</Button>
			</div>
			<img
				src="/images/pepper-inc-tower.png"
				alt="Pepper Inc. Tower"
				className="size-[280px]"
				width={280}
				height={280}
			/>
		</Card>
	)
}
